import { render, staticRenderFns } from "./RsaConfigurazioneDiariEditPage.vue?vue&type=template&id=993ec3d8"
import script from "./RsaConfigurazioneDiariEditPage.vue?vue&type=script&lang=js"
export * from "./RsaConfigurazioneDiariEditPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports